module.exports = __webpack_public_path__ + "static/media/ApercuPro.6118e61e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/customFont/font5/ApercuPro.woff
// module id = 357
// module chunks = 0